import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaQuestionCircle, FaSave, FaTrash, FaPlus, FaEdit } from 'react-icons/fa';
import styles from './Admin.module.css';

const AdminFAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Form State
  const [form, setForm] = useState({
    id: 0,
    question: '',
    answer: '',
    displayOrder: 0
  });



  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    try {
      const res = await api.get('/FAQ');
      setFaqs(res.data);
    } catch (err) {
      console.error("Error fetching FAQs", err);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
     await api.post('/FAQ/save', form, {
  headers: { Authorization: `Bearer ${token}` }
});
      
      setMessage({ text: "FAQ Saved Successfully!", type: "success" });
      fetchFAQs();
      resetForm();
    } catch (err) {
      setMessage({ text: "Error saving FAQ", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this FAQ?")) return;
    try {
      const token = localStorage.getItem('token');
    await api.delete(`/FAQ/delete/${id}`, {
  headers: { Authorization: `Bearer ${token}` }
});
      fetchFAQs();
    } catch (err) {
      alert("Error deleting FAQ");
    }
  };

  const handleEdit = (faq) => {
    setForm(faq);
    window.scrollTo(0, 0);
  };

  const resetForm = () => {
    setForm({ id: 0, question: '', answer: '', displayOrder: 0 });
  };

  return (
    <div className={styles.formCard} style={{ maxWidth: '900px' }}>
      <h3 style={{ marginBottom: '1.5rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <FaQuestionCircle /> Manage FAQs
      </h3>

      {message.text && (
        <div style={{
          padding: '10px', marginBottom: '20px', borderRadius: '5px',
          background: message.type === 'error' ? 'rgba(239,68,68,0.2)' : 'rgba(74,222,128,0.2)',
          color: message.type === 'error' ? '#fca5a5' : '#4ade80'
        }}>
          {message.text}
        </div>
      )}

      {/* --- FORM SECTION --- */}
      <form onSubmit={handleSubmit} style={{ marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid #444' }}>
        <div className={styles.formGroup}>
          <label>Question</label>
          <input 
            className={styles.formInput} 
            name="question" 
            placeholder="e.g. What is the cost of solar?" 
            value={form.question} 
            onChange={handleChange} 
            required 
          />
        </div>

        <div className={styles.formGroup}>
          <label>Answer</label>
          <textarea 
            className={styles.formInput} 
            name="answer" 
            placeholder="Detailed answer here..." 
            value={form.answer} 
            onChange={handleChange} 
            rows="3" 
            required 
          />
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="submit" className={styles.primaryBtn} disabled={loading}>
            {loading ? 'Saving...' : <><FaSave /> {form.id === 0 ? 'Add FAQ' : 'Update FAQ'}</>}
          </button>
          {form.id !== 0 && (
            <button type="button" onClick={resetForm} style={{ background: '#64748b', border: 'none', color: 'white', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' }}>
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* --- LIST SECTION --- */}
      <div>
        <h4 style={{ color: '#fff', marginBottom: '15px' }}>Existing FAQs ({faqs.length})</h4>
        <div style={{ display: 'grid', gap: '15px' }}>
          {faqs.map((faq, index) => (
            <div 
              key={faq.id} 
              style={{ 
                background: 'rgba(255,255,255,0.05)', 
                padding: '15px', 
                borderRadius: '8px',
                borderLeft: '4px solid #4ade80'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, paddingRight: '20px' }}>
                  <h5 style={{ margin: '0 0 5px 0', color: '#fff', fontSize: '1.1rem' }}>
                    <span style={{ color: '#4ade80', marginRight: '10px' }}>Q{index + 1}.</span>
                    {faq.question}
                  </h5>
                  <p style={{ margin: '0', fontSize: '0.95rem', color: '#cbd5e1', lineHeight: '1.6' }}>
                    {faq.answer}
                  </p>
                </div>
                
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button 
                    onClick={() => handleEdit(faq)} 
                    style={{ background: 'transparent', border: 'none', color: '#4ade80', cursor: 'pointer', fontSize: '1.1rem' }}
                    title="Edit"
                  >
                    <FaEdit />
                  </button>
                  <button 
                    onClick={() => handleDelete(faq.id)} 
                    style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '1.1rem' }}
                    title="Delete"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminFAQ;